import ReviewSummaryContent from '../ReviewSummaryContent';
import { FormPanel } from '../styles';
import type { VolunteerFormState } from '../types';

interface Props {
  form: VolunteerFormState;
  serviceAreaLabels: string[];
  onEditStep: (stepIndex: number) => void;
  isTablet: boolean;
}

const ReviewSubmitStep = ({ form, serviceAreaLabels, onEditStep, isTablet }: Props) => (
  <FormPanel isTablet={isTablet}>
    <ReviewSummaryContent form={form} serviceAreaLabels={serviceAreaLabels} onEditStep={onEditStep} />
  </FormPanel>
);

export default ReviewSubmitStep;
